import { Injectable } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';

import { ConfirmDialogService } from '@shared/confirm-dialog';
import {
  ConfirmDialogAnswer,
  ConfirmDialogResults,
} from '@shared/confirm-dialog/confirm-dialog.data';
import { CornerstoneService } from '@viewer/cornerstone.service';
import { ViewerService } from '@viewer/viewer.service';
import {
  ProjectActionsRequestService,
  TimeTrackerService,
} from '@viewer/services';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { Router } from '@angular/router';
import { LogMessageAction } from '@viewer/services/log-event.data';

@Injectable()
export class ExitActionService {
  private _unsubscribe$ = new Subject();
  private _subscribtionToExit: Subscription | null = null;

  constructor(
    private _confirmDialogService: ConfirmDialogService,
    private _cornerstoneService: CornerstoneService,
    private _viewerService: ViewerService,
    private _projectActionsRequestService: ProjectActionsRequestService,
    private _stateManagerProjectService: StateManagerProjectService,
    private _timeTrackerService: TimeTrackerService,
    private _router: Router
  ) {}

  public openConfirmDialog() {
    this._confirmDialogService
      .openConfirmDialog(
        'Dialog.EXIT_MESSAGE',
        'Dialog.RejectButtons.EXIT',
        'Dialog.ConfirmButtons.SAVEEXIT',
        false,
        false
      )
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((res: ConfirmDialogAnswer) => {
        this._stateManagerProjectService.isBoneViewLoaded = false;
        if (res.result === ConfirmDialogResults[2]) {
          return;
        }
        switch (res.result) {
          case ConfirmDialogResults[1]: {
            const checkAndExit = () => {
              if (this._subscribtionToExit === null) {
                this._subscribtionToExit = this.sendExitToBackend(true);
              }
            };
            this._cornerstoneService.saveMask(checkAndExit);
            break;
          }
          case ConfirmDialogResults[0]: {
            this._subscribtionToExit = this.sendExitToBackend(true);
            break;
          }
        }
        this._viewerService.preventAllSubscriptions();
      });
  }

  public sendExitToBackend(isFromButton: boolean = false): Subscription {
    return this._projectActionsRequestService
      .requestExitFromCase(this._stateManagerProjectService.caseId)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((_) => {
        if (isFromButton) {
          this._projectActionsRequestService
            .requestSaveLogForCase(
              this._stateManagerProjectService.caseId,
              this._stateManagerProjectService.currentUserName,
              LogMessageAction.CaseClosed,
              new Date().toISOString(),
              1,
              'UPDATE'
            )
            .subscribe();
          this._timeTrackerService.destroyObservable().subscribe(() => {
            this._timeTrackerService.timeRefresh();
            this._stateManagerProjectService.isAlreadyClosedApp = true;
            this._subscribtionToExit?.unsubscribe();
            this._subscribtionToExit = null;
            this._unsubscribe$.next(undefined);
            this._unsubscribe$.complete();
            this._router.navigateByUrl('activecase');
          });
         
        }
      });
  }
}
